import React from "react";
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <section id="about_us">
      <h2>About Us ☀️</h2>
      <article>
        <p>
          <strong>Mihiret Bonda</strong> is a Bonda cloths and shoe store
          located in Addis Ababa, Ethiopia. The store was established on April
          20, 2023 by Sister Mihiret Dechassa. Since then it has been known for providing quality bonda cloths and shoes to adults, youths and children with highly afforadable prices.
        </p>

      </article>
    </section>
  );
};

export default AboutUs;
